import { createReducer } from "@ec-oem/ec.oem.oa3.ui.core/utility";
import { SET_SETTING_DATA } from "./Setting.action";

export const businessFlagsEntity = createReducer(null, {
	[SET_SETTING_DATA](state, { businessFlagsEntity }) {
		return businessFlagsEntity;
	}
});
